module.exports = __webpack_public_path__ + "static/media/licenta32.23212910.png";